module.exports = __webpack_public_path__ + "static/img/round-flare-33-cap.e600071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/receptacles/round-flare-33-cap.jpg
// module id = 613
// module chunks = 0